export default "__VITE_ASSET__B$8yKrKe__"